<template>
  <div>
    <b-card>
      <!-- Utils -->
      <b-row class="mb-2">
        <b-col cols="3">
          <flat-pickr v-model="rangeDate" class="form-control" :config="{ mode: 'range' }" />
        </b-col>
        <b-col>
          <b-button variant="primary"> Cerca </b-button>
        </b-col>
      </b-row>

      <!-- Table -->
      <b-table :items="mappedInvoices" :fields="fields" striped responsive :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc">
        <template #cell(type)="data">
          <b-badge v-if="
            getInvoiceSerial(data.item.localizator) ===
            AGENCY_CLIENT_INVOICES_SERIES
" variant="success">
            Client (subarrendament)
          </b-badge>
          <b-badge v-if="
            getInvoiceSerial(data.item.localizator) ===
            AGENCY_OWNER_INVOICES_SERIES
          " variant="warning">
            Propietari (comissiò)
          </b-badge>
        </template>
        <template #cell(emittedAt)="data">
          {{ formatDateStringToDate(data.value) }}
        </template>
        <template #cell(actions)="data">
          <b-button variant="flat-success" class="btn-icon" @click="onButtonClicked(data.item.uuid)">
            Veure
            <feather-icon icon="ChevronRightIcon" />
          </b-button>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import { BTable, BButton, BRow, BCol, BCard, BBadge } from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { formatDateStringToDate, formatCurrency } from "@/utils/formatters";
import {
  AGENCY_CLIENT_INVOICES_SERIES,
  AGENCY_OWNER_INVOICES_SERIES,
} from "@appConfig";

export default {
  components: {
    BTable,
    BButton,
    flatPickr,
    BRow,
    BCol,
    BCard,
    BBadge,
  },
  data() {
    return {
      rangeDate: null,
      sortBy: 'emittedAt',
      sortDesc: true,
      fields: [
        { key: "localizator", label: "Factura" },
        { key: "emittedAt", label: "Data", sortable: true },
        { key: "accommodationName", label: "Propietat" },
        { key: "pvpPrice", label: "Total" },
        { key: "type", label: "Tipus" },
        { key: "actions", label: "Accions" },
      ],
      AGENCY_CLIENT_INVOICES_SERIES,
      AGENCY_OWNER_INVOICES_SERIES,
      formatDateStringToDate
    };
  },
  computed: {
    invoices() {
      return this.$store.getters["invoices/invoices"];
    },
    mappedInvoices() {
      if (!this.invoices.length) return [];
      return this.invoices.map((invoice) => ({
        localizator: invoice.localizator,
        accommodationName: invoice.accommodationName,
        emittedAt: invoice.emittedAt,
        pvpPrice: formatCurrency(invoice.pvpPrice),
        uuid: invoice.uuid,
      }));
    },
  },
  created() {
    this.fetchInvoices();
  },
  methods: {
    fetchInvoices() {
      this.$store.dispatch("invoices/fetchInvoices");
    },
    onButtonClicked(uuid) {
      this.$router.push({
        name: "foravila-accounting-billing-invoice-details",
        params: {
          invoiceUuid: uuid,
        },
      });
    },
    getInvoiceSerial(localizator) {
      return localizator.replace(/[0-9]/g, "");
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
